import { render, staticRenderFns } from "./pricesTable.vue?vue&type=template&id=1598616e"
import script from "./pricesTable.vue?vue&type=script&lang=js"
export * from "./pricesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports